import React, { useEffect } from "react";
import { getSupportContactDetails } from "@/stores/classwizeConfigStore";

const Chatbot = (): JSX.Element => {
	const supportContactDetails = getSupportContactDetails();

	useEffect(() => {
		const deviceId = localStorage.getItem("DEVICE");
		const chatbotId = supportContactDetails.support_chatbot_id;
		const supportContactName = supportContactDetails.support_contact_name;
		const supportContactEmail = supportContactDetails.support_contact_email;

		if (supportContactDetails.enable_support_chatbot && deviceId && chatbotId && supportContactName && supportContactEmail) {
			window.__be = window.__be || {};
			window.__be.id = chatbotId;

			window.BE_API = window.BE_API || {};
			window.BE_API.onLoad = () => {
				window.BE_API.setUserAttributes({
					device_id: deviceId,
					district_contact_name: supportContactName,
					district_contact_email: supportContactEmail,
				});
			};

			(function () {
				const be = document.createElement("script");
				be.type = "text/javascript";
				be.async = true;
				be.src = ("https:" === document.location.protocol ? "https://" : "http://") + "cdn.chatbot.com/widget/plugin.js";
				const s = document.getElementsByTagName("script")[0];
				// @ts-expect-error - Leaving code as it is
				s.parentNode.insertBefore(be, s);
			})();
		}

		return () => {};
	}, [supportContactDetails]);

	return <div id="chatbot" />;
};

export default Chatbot;
